// This file is automatically generated. Do not edit it directly.
import { createClient, type SupabaseClient } from "@supabase/supabase-js";
import type { Database } from "./types";
import { SUPABASE_URL, SUPABASE_ANON_KEY } from "@/config/environment";

// Import session helpers from @/services/auth — not this client directly.
// Direct client import is restricted to auth, MFA, realtime, and BaseService modules.
// import { getClientSession } from "@/services/auth/clientSession";

// Lazy initialization - only create client when first accessed
// This ensures window.__ENV__ from config.js is loaded before client creation
let supabaseClient: SupabaseClient<Database> | null = null;

/**
 * Get Supabase Client.
 */
const getSupabaseClient = (): SupabaseClient<Database> => {
  if (!supabaseClient) {
    // Access SUPABASE_URL and SUPABASE_ANON_KEY as values (they're lazy Proxies)
    const url = String(SUPABASE_URL);
    const key = String(SUPABASE_ANON_KEY);

    supabaseClient = createClient<Database>(url, key, {
      auth: {
        autoRefreshToken: true,
        persistSession: true,
        detectSessionInUrl: true, // CRITICAL: Enables OAuth callback processing
      },
    });
  }
  return supabaseClient;
};

// Export as Proxy to maintain API compatibility while enabling lazy initialization
export const supabase: SupabaseClient<Database> = new Proxy({} as SupabaseClient<Database>, {
  get(_target, prop) {
    return getSupabaseClient()[prop as keyof SupabaseClient<Database>];
  },
});
